<template>
  <Modal title="Дата сдачи проекта" @backdrop-click="close">
    <template slot="body">
      <DatePicker
        class="datepicker_manual-deadline"
        v-model="value"
        type="datetime"
        format="YY:MM:DD HH:mm"
        confirm-text="Установить вручную"
        :lang="russianLocale"
        :disabled-date="getDisabledDates"
        :disabled-time="getDisabledTimes"
        confirm
        inline
        @confirm="confirmDate"
      />
    </template>
    <template slot="footer">
      <div>
        <button type="button" class="btn btn-danger" @click="close">
          Отменить
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import russianLocale from 'vue2-datepicker/locale/ru';
import Modal from '@/_shared/components/ui/Modal';
export default {
  emits: ['close', 'set-manually'],
  components: {
    DatePicker,
    Modal,
  },
  props: {
    workShifts: {
      type: Object | null,
      default() {
        return {};
      },
    },
    initDate: {
      type: String | null,
      default: null,
    },
  },
  data() {
    return {
      value: new Date(),
      russianLocale,
    };
  },
  watch: {
    initDate: {
      handler(newValue) {
        if (newValue !== null) {
          this.value = newValue;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  methods: {
    getDisabledTimes(date) {
      const localeDay = date.toLocaleDateString('sv');
      const hours = date.getHours();
      const { start, end } = this.workShifts[localeDay];
      const startHour = parseInt(start.split(':')[0]);
      const endHour = parseInt(end.split(':')[0]);
      return !!(hours < startHour || hours > endHour);
    },
    getDisabledDates(date) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const localeDay = date.toLocaleDateString('sv');
      const dayIsWorkShift = !!this.workShifts[localeDay];
      return !!(date < yesterday || !dayIsWorkShift);
    },
    confirmDate(value) {
      this.$emit('set-manually', value);
      this.close();
    },
    close() {
      document.querySelector('body').style.overflow = 'auto';
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.datepicker_manual-deadline {
  z-index: 4000;
}
</style>



// WEBPACK FOOTER //
// src/stock/components/ManualDeadlineModal.vue